import {
  getMaskTextFieldRendererProps,
  getRendererProps,
  MaskTextFieldRenderer,
  SearchSelectionRenderer,
  TextFieldRenderer,
} from '@exam-center/components';
import { ID_CARD_NUMBER_MASK } from '@exam-center/utils';
import { Flex, SectionTitle } from '@shared/components';
import { THAI_TITLE_OPTIONS } from '@shared/utils';

export default function ThirdProctorInformationFormField() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <SectionTitle title='ข้อมูลผู้คุมสอบ' />
      <MaskTextFieldRenderer
        {...getMaskTextFieldRendererProps(
          { mode: 'input', name: 'personal.idNumber' },
          { mask: ID_CARD_NUMBER_MASK },
          {
            label: 'เลขบัตรประชาชน',
            placeholder: 'กรอกเลขบัตรประชาชน',
            required: true,
          },
        )}
      />
      <Flex sx={{ flex: 1, gap: (theme) => theme.spacing(4) }}>
        <SearchSelectionRenderer
          mode='input'
          name='personal.titleTh'
          slotProps={{
            options: THAI_TITLE_OPTIONS,
            label: 'คำนำหน้าชื่อ',
            placeholder: 'เลือกคำนำหน้า',
            required: true,
            sx: { flexBasis: '260px' },
          }}
        />
        <TextFieldRenderer
          {...getRendererProps(
            { mode: 'input', name: 'personal.firstNameTh', slotProps: {} },
            {
              sx: { flex: 1 },
              label: 'ชื่อภาษาไทย',
              placeholder: 'กรอกชื่อภาษาไทย',
              required: true,
            },
          )}
        />
        <TextFieldRenderer
          {...getRendererProps(
            { mode: 'input', name: 'personal.lastNameTh', slotProps: {} },
            {
              sx: { flex: 1 },
              label: 'นามสกุลภาษาไทย',
              placeholder: 'กรอกนามสกุลภาษาไทย',
              required: true,
            },
          )}
        />
      </Flex>
      <TextFieldRenderer
        {...getRendererProps(
          { mode: 'input', name: 'personal.email', slotProps: {} },
          {
            label: 'อีเมลผู้ใช้ (อีเมลบริษัทเท่านั้น)',
            placeholder: 'กรอกอีเมลผู้ใช้',
          },
        )}
      />
    </Flex>
  );
}
